export default __webpack_public_path__ + "static/media/svg-7.31386bfa.svg";